import { Type } from 'class-transformer';

export class SearchArchitecturalApplicationsResultDto {
    accId: number;
    project: string;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    createdOn: Date;

    accItemId: number;
    description: string;
    propertyAddress: string;
    owner: string;
    accountNumber: number;
    communityId: number;
    community: string;
    location: string;
}
